export default "__VITE_ASSET__Bf22o9XC__"